export { default } from './IconTextLabel'
